var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_527_2476)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30081 3.87837C4.76407 4.17737 3.39949 5.65472 3.76218 7.57648C4.05777 9.14263 5.55499 10.4874 7.49726 10.1191C10.0665 9.63201 11.0788 6.28119 8.80997 4.47097C8.22087 4.00102 7.26162 3.69132 6.30081 3.87826V3.87837ZM6.40877 4.66539C5.27248 4.90499 4.26136 6.03338 4.54761 7.45268C4.77796 8.59458 5.91831 9.64748 7.37539 9.33248C8.4924 9.09102 9.51077 7.96542 9.22431 6.54529C8.99251 5.39623 7.84968 4.36161 6.40877 4.66549V4.66539Z",
    fill: "#22242C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71422 11.0141C6.35412 11.1809 6.48356 11.9414 6.48366 12.3683C6.48366 12.5519 6.46033 12.9542 6.51706 13.1086C6.58551 13.2947 6.82385 13.4172 7.0543 13.3169C7.42031 13.1576 7.28444 12.3713 7.28455 11.969C7.28465 11.6037 7.35787 10.7161 6.71422 11.0141Z",
    fill: "#22242C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73028 0.684596C6.49319 0.796242 6.48458 0.924504 6.48396 1.22911C6.48344 1.48315 6.4601 2.60594 6.51424 2.77273C6.58083 2.97764 6.82694 3.09282 7.06455 2.99353C7.41863 2.84564 7.28505 2.03296 7.28515 1.62948C7.28515 1.43776 7.31378 1.05329 7.25165 0.889401C7.17936 0.698721 6.94497 0.58344 6.73028 0.684596Z",
    fill: "#22242C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1479 6.61709C10.7614 6.7197 10.6629 7.39404 11.3808 7.39768C11.6464 7.39903 12.7886 7.42489 12.9588 7.37254C13.3264 7.25955 13.4026 6.6092 12.7158 6.59954C12.4536 6.59591 11.3103 6.57389 11.1478 6.61699L11.1479 6.61709Z",
    fill: "#22242C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.801855 6.63431C0.380255 6.8225 0.424126 7.39693 1.09993 7.39734C1.37156 7.39755 2.4924 7.42777 2.66758 7.3665C3.00237 7.24935 3.11365 6.59879 2.34482 6.60014C2.06157 6.60066 0.975473 6.55683 0.801751 6.63431H0.801855Z",
    fill: "#22242C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.62715 9.73893C3.45934 9.82025 2.82834 10.5103 2.65213 10.6824C2.5315 10.8001 2.25728 10.9898 2.28518 11.2558C2.31402 11.5308 2.6096 11.6969 2.86484 11.5596C2.95508 11.5111 3.68554 10.7558 3.827 10.6165C3.95696 10.4886 4.201 10.3015 4.18969 10.0655C4.17642 9.78754 3.91972 9.59706 3.62715 9.73893Z",
    fill: "#22242C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79604 9.74909C9.68113 9.8059 9.6272 9.79261 9.5881 9.9942C9.55709 10.1542 9.59339 10.2496 9.67885 10.3466L10.6344 11.2997C10.7684 11.4334 10.935 11.6989 11.2581 11.5798C11.4847 11.4962 11.5761 11.17 11.3843 10.9474C11.2421 10.7824 11.0561 10.6283 10.8945 10.4623C10.5065 10.0636 10.1521 9.57316 9.79604 9.74909Z",
    fill: "#22242C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9807 2.41012C10.8593 2.44626 9.60784 3.63542 9.5817 3.85653C9.54613 4.15823 9.78021 4.36532 10.0883 4.29044C10.1709 4.27039 11.4686 3.04655 11.4865 2.82586C11.5115 2.51813 11.2597 2.32714 10.9806 2.41022L10.9807 2.41012Z",
    fill: "#22242C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.58914 2.39578C2.34085 2.4474 2.19015 2.75917 2.345 2.99991L3.29824 3.95684C3.44728 4.1066 3.58594 4.37559 3.92519 4.28472C4.14517 4.22583 4.28591 3.93638 4.13242 3.70105L3.18042 2.74297C3.0542 2.6146 2.87747 2.33585 2.58904 2.39578H2.58914Z",
    fill: "#22242C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_527_2476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.7059,
    height: 12.7059,
    fill: "white",
    transform: "translate(0.529297 0.647095)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.62286c99ad628fc626440f931d1a7211.svg";
export { ForwardRef as ReactComponent };